'use client'
import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {Col, Container, Form, Row} from "react-bootstrap";
import Button from "@/components/Button";
import {hover, marengo, text, white} from "@/styles/globalStyleVars";
import {toast} from "react-toastify";
import Title from "@/components/Title";
import {Img} from "@/components/Img";
import axios from "axios";
import {useForm} from "react-hook-form";


const GetInTouch = ({title,img,form_id, form_tag}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { register, handleSubmit, formState, reset, setError,clearErrors  } = useForm({ mode: "all" });
    const { errors, isSubmitting: isFormSubmitting } = formState;

    const success = (msg) => toast.success(msg, { position: "top-right", autoClose: 4000, closeOnClick: true });
    const error = (msg) => toast.error(msg, { position: "top-right", autoClose: 4000, closeOnClick: true });

    const [cv, setCv] = useState(null);
    const [selectedFileName, setSelectedFileName] = useState('');

    const handleFileChange = (event) => {
        setCv(event.target.files[0]);
        setSelectedFileName(event.target.files[0]?.name);
        clearErrors("fileCv"); // Clear error when file changes
    };


    const onSubmit = async (data) => {
        if (!cv) {
            setError("fileCv", { type: "manual", message: "Attach your resume." });
            return;
        }
        setIsSubmitting(true); // Show spinner
        try {
            const formData = new FormData();
            formData.append("_wpcf7_unit_tag", "form_" + (form_tag || "6ed4a9d"));
            formData.append("your-name", data.name);
            formData.append("email", data.email);
            formData.append("phone", data.phone);
            formData.append("message", data.message);
            formData.append("file-cv", cv);

            const response = await axios.post(
                `https://cms.ups-bd.com/wp-json/contact-form-7/v1/contact-forms/${form_id || '149'}/feedback`,
                formData
            );
            if (response.status === 200) {
                success(response.data.message);
                reset();
                setCv(null);
                setSelectedFileName('');
            } else {
                error("Failed to submit form. Please try again later.");
            }
        } catch (err) {
            error(err.message || "Failed to submit form. Please try again later.");
        } finally {
            setIsSubmitting(false); // Hide spinner
        }
    };

    const onError = (errors) => {
        const firstError = Object.values(errors)[0];
        error(firstError.message);
    };


    return (
        (<StyledGetInTouch className="enquiry pt-120 pb-120">
            <Container>
                <Row>
                    <Col xs={12} sm={12} md={5} className='contact-from-left'>
                        <div className='contact-from-left__inner'>
                            <Title text={title} color={`${white}`} />
                            <Form className={'form'}>

                                {/* Name Field */}
                                <Form.Group controlId="formName">
                                    <Form.Control
                                        className={errors.name ? "has-error form-control-lg" : "form-control-lg"}
                                        {...register("name", {
                                            required: "Enter your full name",
                                            pattern: {
                                                value: /^[A-Za-z ]+$/,
                                                message: "Name must contain only letters",
                                            },
                                        })}
                                        type="text"
                                        placeholder="Name*"
                                        disabled={isFormSubmitting}
                                    />
                                    {errors.name && <span className="error-message form-error">{errors.name.message}</span>}
                                </Form.Group>

                                {/* Email and Phone Fields */}
                                <div className="phoneEmail">
                                    <Form.Group controlId="formPhone">
                                        <Form.Control
                                            className={errors.phone ? "has-error form-control-lg" : "form-control-lg"}
                                            {...register("phone", {
                                                required: "Enter your phone number",
                                                pattern: {
                                                    value: /^01[0-9]{9}$/,
                                                    message: "Enter a valid 11-digit phone number",
                                                },
                                            })}
                                            type="number"
                                            placeholder="Phone / WhatsApp*"
                                            disabled={isFormSubmitting}
                                        />
                                        {errors.phone && <span className="error-message form-error">{errors.phone.message}</span>}
                                    </Form.Group>
                                    <Form.Group controlId="formEmail">
                                        <Form.Control
                                            className={errors.email ? "has-error form-control-lg" : "form-control-lg"}
                                            {...register("email", {
                                                required: {
                                                    value: false,
                                                    message: "Enter a valid email address",
                                                },
                                                pattern: {
                                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                    message: "Enter a valid email address",
                                                },
                                            })}
                                            type="email"
                                            placeholder="Email"
                                            disabled={isFormSubmitting}
                                        />
                                        {errors.email && <span className="error-message form-error">{errors.email.message}</span>}
                                    </Form.Group>


                                </div>

                                {/* Message Field */}
                                <Form.Group controlId="formMessage">
                                    <Form.Control
                                        as="textarea"
                                        rows={4}
                                        className={errors.message ? "has-error form-control-lg" : "form-control-lg"}
                                        {...register("message", {
                                            required: {
                                                value: false,
                                                message: "Enter your Message",
                                            },
                                        })}
                                        placeholder="Message"
                                        disabled={isFormSubmitting}
                                    />
                                    {errors.message && <span className="form-error error-message">{errors.message.message}</span>}
                                </Form.Group>

                                {/* File Upload Field */}
                                <div className="button-group">
                                    <div className="attachCvName">
                                        <div className="attach-cv">
                                            <Form.Control
                                                type="file"
                                                accept=".pdf"
                                                id="resume-upload"
                                                style={{ display: "none" }}
                                                onChange={handleFileChange}
                                            />
                                            <Form.Label htmlFor="resume-upload" className="resume-upload-label" style={{ display: selectedFileName ? "none" : "block" }}>
                                                Attach Resume
                                            </Form.Label>
                                            {selectedFileName && <div className="file-name">{selectedFileName}</div>}
                                            {errors.fileCv && <span className="error-message form-error">{errors.fileCv.message}</span>}
                                        </div>
                                    </div>
                                </div>

                                {/* Submit Button */}
                                <div style={{ width: "100%" }} onClick={handleSubmit(onSubmit, onError)}>
                                    <Button text={'Submit Message'}
                                            border={`1px`}
                                            borderColor={`${white}`}
                                            hoverBackground={`${hover}`}
                                            color={`${white}`}
                                            padding={'10px 20px'}
                                    />
                                </div>

                            </Form>
                        </div>
                    </Col>

                    <Col xs={12} sm={12} md={7} className='contact-from-right'>
                        <div className="contact-from-right__image ">
                            <Img src={img} />
                        </div>
                    </Col>
                </Row>
            </Container>
        </StyledGetInTouch>)
    );
};


const StyledGetInTouch = styled.section`
    background: #fff;
    
    .button-group {
        div {
            width: 100% !important;
        }
    }
    
    h2{
        font-weight: 800;
    }

    form {

    }

    .dc-btn {
        a {
            width: 100%;
        }
    }

    .button-group {
        display: flex;


        .attach-cv {
            //width: -webkit-fill-available;
            cursor: pointer;
            border: 1px solid ${white};
            border-radius: 28px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            margin-bottom: 30px;
            //margin-top: 60px;
            //margin-right: 60px;

            label {
                margin-bottom: 0;
                cursor: pointer;
                color: ${white};
            }

            .file-name {
                font-size: 14px;
                opacity: 0.8;
                color: ${white};
                padding-left: 10px;
            }

            @media (max-width: 767px) {
                width: 100%;

            }
        }

        @media (max-width: 767px) {
            flex-direction: column;

        }
    }


    .contact-from-right {
        padding-left: 0;

        &__image {
            padding-top: calc(570 / 670 * 100%);
            position: relative;
            height: 100%;
        }
    }

    .contact-from-left {
        padding-right: 0;


        &__inner {
            background-color: ${marengo};
            padding: 70px 70px 107px 70px;
            height: 100%;

            h3 {
                font-size: 40px;
                font-weight: 700;
                line-height: 46px;
                color: ${text};
                margin-bottom: 0;
            }

            form {
                margin-top: 40px;
            }

            .form-group {
                margin-bottom: 30px !important;
            }

            .form-control {
                margin-bottom: 30px !important;
                height: 50px;
                line-height: 53px;
                color: ${white};
                font-size: 14px;
                font-weight: 500;
                line-height: 20px;
                border-radius: 0;
                border: none;
                border-bottom: 1px solid #D1D1D1;
                background-color: transparent;
                padding: 0;

                &::placeholder {
                    font-size: 14px;
                    color: ${white};
                    opacity: .6;
                    line-height: 20px;
                    font-weight: 500;
                    margin-bottom: 15px;
                }
            }
        }
    }

    @media (min-width: 1550px) {
        .contact-from-right {
            &__image {
                padding-top: calc(800 / 822 * 100%);
            }
        }

        .contact-from-left {
            &__inner {

                h3 {
                    font-size: 48px;
                    line-height: 56px;
                }

                .form-control {
                    font-size: 16px !important;
                }
            }
        }
    }

    @media (max-width: 1091px) {
        .contact-from-left {
            &__inner {
                padding: 40px 30px 65px 30px;
            }
        }
    }

    @media (max-width: 767px) {

        .row {
            flex-direction: column-reverse;
        }

        .contact-from-right {
            padding-left: 15px;

            &__image {
                padding-top: calc(300 / 345 * 100%);
            }
        }

        .contact-from-left {
            padding-right: 15px;

            &__inner {
                padding: 40px 15px;

                h3 {
                    font-size: 32px !important;
                    line-height: 36px;
                    margin-bottom: 40px;
                }

                .form-group {
                    margin-bottom: 30px !important;
                }

                .form-top {
                    font-size: 16px !important;
                }

                form {
                    margin-top: 40px;
                    padding-right: 0;
                }

                .dc-btn {
                    width: 100%;
                }
            }
        }
    }
`

export default GetInTouch;